package floris.graphics.models.domain.models

import floris.graphics.models.domain.models.interfaces.DateAble
import floris.graphics.models.dto.requests.contributor.ContributorDto
import org.w3c.dom.url.URL

data class Contributor(
    val id: String = "",
    val name: String = "",
    val website: URL? = null,
    val logoMediaFile: MediaFile? = null,
    val bio: String? = null,
    override val createdAt: String = "",
    override val updatedAt: String = ""
) : DateAble

fun Contributor.toDto() = ContributorDto(
    id = this.id,
    name = this.name,
    website = this.website?.toString(),
    logoMediaFile = this.logoMediaFile?.toDto(),
    bio = this.bio,
    createdAt = this.createdAt,
    updatedAt = this.updatedAt
)

fun ContributorDto.toContributor() = Contributor(
    id = this.id,
    name = this.name,
    website = this.website?.let(::URL),
    logoMediaFile = this.logoMediaFile?.toMediaFile(),
    bio = this.bio,
    createdAt = createdAt,
    updatedAt = updatedAt
)